(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dusak-landing-stranka-007OMEGA"] && !Shopify.designMode) return;
  try {
    
/* =========================================================================
   OMEGA × 007 – landing page Klenotnictví Dušák
   Sdílený skript pro sekce o7-*.liquid. Bez knihoven, bez jQuery.
   Načítá se s atributem defer; i když je vložen vícekrát, spustí se jednou.
   ========================================================================= */
(function () {
  if (window.DusakO7) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  /* ---------- Jemné objevení obsahu ---------- */
  var revealIO = hasIO
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealIO.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -48px 0px' })
    : null;

  function initReveal(section) {
    var items = section.querySelectorAll('.o7-reveal, .o7-g');
    if (!section.classList.contains('o7--anim') || !revealIO || reduceMotion) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    section.classList.add('o7--js');
    var group = 0;
    var lastParent = null;
    items.forEach(function (el) {
      var parent = el.parentElement;
      group = parent === lastParent ? Math.min(group + 1, 5) : 0;
      lastParent = parent;
      el.style.setProperty('--o7-d', group * 90 + 'ms');
      revealIO.observe(el);
    });
  }

  /* ---------- Hero: pomalý nástup obrázku + video s fallbackem ---------- */
  var videoIO = hasIO
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting && !reduceMotion) {
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.05 })
    : null;

  function initHero(section) {
    if (!section.classList.contains('o7-hero')) return;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () { section.classList.add('is-loaded'); });
    });

    section.querySelectorAll('video[data-o7-video]').forEach(function (video) {
      var fail = function () { video.classList.add('is-failed'); };
      video.addEventListener('error', fail);
      var source = video.querySelector('source');
      if (source) source.addEventListener('error', fail);

      if (reduceMotion) {
        video.removeAttribute('autoplay');
        video.pause();
        fail();
        return;
      }

      var p = video.play();
      if (p && p.catch) p.catch(function () { /* autoplay zablokován – zůstane poster/obrázek */ });
      if (videoIO) videoIO.observe(video);
    });
  }

  /* ---------- Posuvná časová osa ---------- */
  function initScroller(section) {
    section.querySelectorAll('[data-o7-scroller]').forEach(function (wrap) {
      var track = wrap.querySelector('.o7-scroller__track');
      var prev = wrap.querySelector('[data-o7-prev]');
      var next = wrap.querySelector('[data-o7-next]');
      var bar = wrap.querySelector('[data-o7-progress]');
      if (!track) return;

      var items = track.querySelectorAll('.o7-scroller__item');

      function step() {
        if (!items.length) return track.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return items[0].getBoundingClientRect().width + gap;
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var isStatic = max <= 2;
        wrap.classList.toggle('is-static', isStatic);
        if (isStatic) return;
        var ratio = Math.min(1, Math.max(0, track.scrollLeft / max));
        var visible = track.clientWidth / track.scrollWidth;
        if (bar) {
          bar.style.width = visible * 100 + '%';
          bar.style.left = ratio * (1 - visible) * 100 + '%';
        }
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ left: step(), behavior: 'smooth' }); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: -step(), behavior: 'smooth' }); }
      });

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; update(); });
      }, { passive: true });

      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Jemný parallax ---------- */
  var parallaxItems = [];
  var parallaxTicking = false;

  function runParallax() {
    parallaxTicking = false;
    var vh = window.innerHeight;
    parallaxItems.forEach(function (el) {
      var box = el.parentElement.getBoundingClientRect();
      if (box.bottom < 0 || box.top > vh) return;
      var progress = (box.top + box.height / 2 - vh / 2) / (vh + box.height);
      el.style.transform = 'translate3d(0,' + (progress * -12).toFixed(2) + '%,0)';
    });
  }

  function onParallaxScroll() {
    if (parallaxTicking) return;
    parallaxTicking = true;
    requestAnimationFrame(runParallax);
  }

  function initParallax(section) {
    if (reduceMotion) return;
    section.querySelectorAll('[data-o7-parallax]').forEach(function (el) {
      if (parallaxItems.indexOf(el) === -1) parallaxItems.push(el);
    });
    if (parallaxItems.length === 1) {
      window.addEventListener('scroll', onParallaxScroll, { passive: true });
      window.addEventListener('resize', onParallaxScroll);
    }
    runParallax();
  }

  /* ---------- Inicializace ---------- */
  function init(section) {
    if (!section || section.dataset.o7Ready === 'true') return;
    section.dataset.o7Ready = 'true';
    initReveal(section);
    initHero(section);
    initScroller(section);
    initParallax(section);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-o7]').forEach(init);
  }

  window.DusakO7 = { init: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme editor: znovu inicializovat po úpravě sekce, vybraný blok hned zobrazit */
  document.addEventListener('shopify:section:load', function (e) {
    parallaxItems = parallaxItems.filter(function (el) { return document.body.contains(el); });
    initAll(e.target);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var section = e.target.closest('[data-o7]');
    if (!section) return;
    e.target.querySelectorAll('.o7-reveal').forEach(function (el) { el.classList.add('is-visible'); });
    if (e.target.classList.contains('o7-g') || e.target.classList.contains('o7-reveal')) {
      e.target.classList.add('is-visible');
    }
    var track = e.target.closest('.o7-scroller__track');
    if (track) {
      track.scrollTo({ left: e.target.offsetLeft - track.offsetLeft - 40, behavior: 'smooth' });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.header.classList.remove('section-header--transparent');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.header.classList.remove('section-header--transparent');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.header.classList.add('section-header--transparent');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
